import { DrawerBody, DrawerFooter } from "@chakra-ui/react";
import type { HeaderNavProps } from "../../HeaderNav.d";

export const MobileMenuContent = ({
  headerButtons,
  menuItems,
}: Pick<HeaderNavProps, "headerButtons" | "menuItems">) => (
  <>
    <DrawerBody px={10} mt={20}>
      {menuItems}
    </DrawerBody>
    {headerButtons && (
      <DrawerFooter flexDirection="column" p={10} boxShadow="0px 8px 32px rgba(45, 60, 77, 0.1)">
        {headerButtons}
      </DrawerFooter>
    )}
  </>
);
